import toast from '@/plugins/sweetalert2.js';
import i18n from '@/plugins/i18n.js';

import {
  ApiConditionPool,
  ApiFiltrationSave,
  ApiFiltrationFetch
} from '@/api/filtrations.js';

export async function conditionPool() {
  const data = await ApiConditionPool();
  let tab = '';
  let tabItems = [];
  let pool = {};
  let poolAll = [];
  if (!data.msg) {
    tab = data.conditionPool[0][0];
    data.conditionPool.forEach((item) => {
      const obj = {
        text: item[0] || '- -',
        value: item[0] || '- -'
      };
      tabItems.push(obj);
      pool[item[0]] = item[1];
      poolAll.push(item[1]);
    });
  }
  return {
    tab,
    tabItems,
    pool,
    poolAll
  };
}

export async function saveFiltration({ uuid, data }) {
  const form = {
    uuid,
    data
  };
  const saveData = await ApiFiltrationSave(form);
  if (!saveData.msg) {
    toast.fire({
      toast: true,
      icon: 'success',
      iconColor: 'green',
      text: i18n.global.t('save_success')
    });
  }
}

export async function trialCalculation({ uuid, data }) {
  const form = {
    uuid,
    data
  };
  const fetchData = await ApiFiltrationFetch(form);
  if (!fetchData.msg) {
    toast.fire({
      toast: true,
      icon: 'success',
      iconColor: 'green',
      text: i18n.global.t('filter_list')
    });
    return fetchData;
  }
}
